import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Layout from 'components/common/layout/Layout';
import RegisterChartModal from 'pages/modal/RegisterChartModal';
import ChartTable from 'components/pages/student/patientDetail/ChartTable';
import PatientCard from 'components/pages/student/patientDetail/PatientCard';
import Footer from 'components/common/layout/Footer';
import 'swiper/css';
import 'swiper/css/pagination';
import { TPatientCardInfo } from 'types/apis/patient';
import { ROUTE_PATH } from 'constants/routePath';
import useModal from 'hooks/useModal';
import { getPatientCardInfo } from 'apis/patient';

const PatientDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const patientId = id as string;

  const { openModal } = useModal();

  const { data: getPatientCardInfoData } = useQuery(
    ['getPatientCardInfo', patientId],
    () => getPatientCardInfo(patientId),
    {
      enabled: !!patientId,
      onError: () =>
        openModal({
          title: '대상자 조회 실패',
          text: '다시 시도해 주세요.',
          onSubmit: () => navigate(ROUTE_PATH.student.PATIENT_MANAGEMENT),
          onClickOutside: () => navigate(ROUTE_PATH.student.PATIENT_MANAGEMENT),
        }),
    }
  );

  const patientCardInfo: TPatientCardInfo = {
    name: getPatientCardInfoData?.data?.name || '',
    ageAndSex: getPatientCardInfoData?.data?.ageAndSex || '',
    agreeOrNot: getPatientCardInfoData?.data?.agreeOrNot || '비동의',
    complaint: getPatientCardInfoData?.data?.complaint || '',
  };

  const handleCreateChart = () =>
    openModal({
      ...(patientCardInfo.agreeOrNot === '동의'
        ? {
            element: <RegisterChartModal patientId={patientId} />,
          }
        : {
            title: '차트 생성 불가',
            text: '대상자가 개인정보 활용 동의를 하지 않았습니다.',
          }),
    });

  return (
    <div className="min_h100vh flex flex_column">
      <div className="grow_1">
        <Layout
          bgColor={true}
          subNav={true}
          setIsModalOpen={handleCreateChart}
          hideFooter={true}
          mode="patientDetail"
        >
          {/* 대상자 카드 */}
          <PatientCard patientInfo={patientCardInfo} />
        </Layout>
        <div className="table_container">
          {/* 대상자 차트 테이블 */}
          <ChartTable />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PatientDetail;
